import { FormOpenMode, ModalSize, OpenMode } from '../enums'
import { SitemapType } from './sitemap-type'

export abstract class SitemapItem {
  public msName: string
  public idml: string
  public description: string
  public tDescription: string
  public openMode: OpenMode
  public modalSize: ModalSize
  public modalSizeHorizontal: ModalSize
  public modalSizeVertical: ModalSize
  public url: string
  public type: SitemapType
  public iconTag: string
  public position: number

  public subDescription: {
    idml: string
    description: string
    tDescription: string
  }
  /**
   * Specify if the Sitemap is related to Application that handle patients
   */
  public handlePatients: boolean
  /**
   * View to count patients
   **/
  public countPatientsView: string

  /**
   * It's used to switch sitemap after click
   * on a current sitemap voice (the nre sitemap
   * must have the same context of the current sitemap)
   */
  public associatedSiteMap: string
  public appName: string
  public asSubItems: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public detailView: any
  public id: string
  public canBeHidden: boolean
  public isVisible: string
  public parameter: string
  public formOpenMode: FormOpenMode

  constructor(model: SitemapItem) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-extra-semi
    ;(<any>this).$type = (<any>model).$type
    this.msName = model.msName
    this.idml = model.idml
    this.description = model.description
    this.tDescription = model.tDescription
    this.openMode = model.openMode
    this.modalSize = model.modalSize
    this.modalSizeHorizontal = model.modalSizeHorizontal
    this.modalSizeVertical = model.modalSizeVertical
    this.url = model.url
    this.associatedSiteMap = model.associatedSiteMap
    this.appName = model.appName
    this.asSubItems = model.asSubItems
    this.detailView = model.detailView
    this.id = this.idml
    this.subDescription = model.subDescription
    this.handlePatients = model.handlePatients
    this.countPatientsView = model.countPatientsView
    this.type = model.type
    this.canBeHidden = model.canBeHidden
    this.id = model.id
    this.isVisible = model.isVisible
    this.parameter = model.parameter
    this.iconTag = model.iconTag
    this.formOpenMode = model.formOpenMode
    this.position = model.position
  }
}
